export const STALE_TIME: number = 600000; // 10 minutes in MS
export const CACHE_TIME: number = 1800000; // 30 minutes in MS
export const PAGE_SIZE: number = 20;
